module.exports = __webpack_public_path__ + "media/landing_page/responsive_mobile-061eab22.svg";